import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import $ from "jquery"
import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import EventBus from "../common/EventBus.js"
import GlobalHelper from '../common/GlobalHelper.jsx'
import Icon from "../common/icon/icon.component.jsx"
import Image from '../common/image/image.component.jsx'
import AddPricingRow from "../common/pricing/addItem.component.jsx"
import PricingTableTotals from "../common/pricing/totals.component.jsx"
import QuoteCurrency from "../common/quote/currency.component.jsx"
import QuoteIdentifier from "../common/quote/identifier.component.jsx"
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import PricingTableContent from '../pricing/PricingTableContentComponent.jsx'
import { fetchPriceLevels } from '../state/price-level/PriceLevelActions'
import {
    setPricingTable,
    setPricingTableGroupItems,
    setPricingTableGroups,
    setPricingTableInitialState,
    setPricingTableItems
} from '../state/pricing/actions'

const messages = defineMessages({
    "group_default_name": {
        id: 'quote.edit.group.group_default_name',
        defaultMessage: 'Group',
    }
})

class QuoteForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            quoteSubtotalAmount: '0.00',
            quoteTaxTotal: '0.00',
            quoteTotalAmount: '0.00',
            quoteTotalCost: '0.00',
            quoteDiscountTotalAmount: '0.00',
            quoteDiscountValue: '0',
            quoteDiscountType: 'none',
            margin: '0.00',
            depositAmount: '0',
            depositRatio: 0,
            quoteItems: [],
            advices: [],
            taxCalculations: [],
            totals: [],
            groups: [],
            exchangeRate: '',
            addItemModal: '',
            setDiscountModal: '',
            setTaxModal: '',
            quoteStatus: '',
            currency: '',
            depositType: "",
            modelId: '',
            identifier: '',
            deletedAt: '',
            forceAllowEdit: this.props.forceAllowEdit || false,
            className: this.props.className || 'ui-module px-3 py-0',
            locationId: null,
            quote: null,
        }
        this.projectId = this.props.projectId
        this.quoteId = this.props.quoteId

        this.onAddQuoteItemModal = this.onAddQuoteItemModal.bind(this)
        this.onUpdateItemList = this.onUpdateItemList.bind(this)
        this.onCloseModal = this.onCloseModal.bind(this)
        this.openSectionAddQuoteItemModal = this.openSectionAddQuoteItemModal.bind(this)
        this.openEditQuoteItemModal = this.openEditQuoteItemModal.bind(this)
        this.refreshQuote = this.refreshQuote.bind(this)
        this.addGroup = this.addGroup.bind(this)
        this.setGlobalStateInitialValues = this.setGlobalStateInitialValues.bind(this)
        this.handleSilentRefresh = this.handleSilentRefresh.bind(this)
        EventBus.listen(EventBus.TopicRefreshQuoteFormSilently, 'quote-form', this.handleSilentRefresh)
    }

    componentDidMount() {
        this.props.setPricingTableInitialState()
        this.refreshQuote()
        this.refreshAdvices()
    }

    componentWillReceiveProps(nextProps) {
        if (this.quoteId === "" || this.quoteId !== nextProps.quoteId) {
            this.refreshQuote()
            this.refreshAdvices()
        }
        this.projectId = nextProps.projectId
        this.quoteId = nextProps.quoteId
    }

    handleSilentRefresh() {
        this.refreshQuote()
    }

    refreshQuote() {
        const currentIdentifier = this.state.identifier
        AppContext.getApiClient().get('/quotes/' + this.quoteId).then(quote => {
            this.setState({
                quote: quote,
                margin: quote.attributes.margin,
                quoteTotalCost: quote.attributes.totalCost,
                quoteTaxTotal: quote.attributes.taxTotal,
                quoteSubtotalAmount: quote.attributes.subtotalAmount,
                quoteTotalAmount: quote.attributes.totalAmount,
                quoteDiscountTotalAmount: quote.attributes.discountTotalAmount,
                quoteDiscountValue: quote.attributes.discountValue,
                quoteDiscountType: quote.attributes.discountType,
                quoteStatus: quote.attributes.status,
                groups: quote.attributes.groups,
                totals: quote.attributes.totals,
                taxId: quote.attributes.taxId,
                modelId: quote.attributes.modelId,
                currency: quote.attributes.currency,
                exchangeRate: quote.attributes.exchangeRate,
                identifier: quote.attributes.identifier,
                identifierId: quote.attributes.identifierId,
                taxCalculations: quote.attributes.taxCalculations,
                deletedAt: quote.attributes.deletedAt,
                quoteItems: quote.attributes.items,
                depositAmount: quote.attributes.depositAmount,
                depositType: quote.attributes.depositType,
                depositRatio: quote.attributes.depositRatio,
                locationId: quote.attributes.locationId,
            }, () => {
                this.setGlobalStateInitialValues()
                if (this.props.onRefreshItemList) {
                    this.props.onRefreshItemList(this.state.quoteItems, quote, this.state.quoteStatus)
                }
                if (currentIdentifier !== quote.attributes.identifier) {
                    EventBus.dispatch(EventBus.TopicUrlPathChange, {
                        path: '/quotes/' + this.quoteId + '/edit',
                    })
                }
            })
        })
    }

    refreshAdvices() {
        return AppContext.getApiClient().get('/quotes/' + this.quoteId + '/advices').then((response) => {
            this.setState({ advices: response.data })
        })
    }

    recommendations() {
        return this.state.advices?.filter((advice) =>
            advice.attributes.type === "recommendation"
        ) ?? []
    }

    onAddQuoteItemModal(keepOpen) {
        this.refreshQuote()
        this.refreshAdvices()
        if (keepOpen) {
            return
        }
        this.setState({
            addItemModal: ''
        })
    }

    onCloseModal() {
        this.refreshQuote()
        this.setState({
            addItemModal: '',
            attachCustomerModal: ''
        })
    }

    onUpdateItemList(q, r) {
        this.refreshQuote()
        this.refreshAdvices()
    }

    openAddQuoteItemModal(productId) {
        return function (e) {
            this.setState({
                addItemModal: <AddPricingRow
                    mainObject={'quotes'}
                    mainObjectItem={'quote-items'}
                    objectId={this.quoteId}
                    objectIdentifier={this.state.identifier}
                    onClose={this.onCloseModal}
                    productId={productId}
                    sectionId=""
                    currency={this.state.currency}
                    exchangeRate={this.state.exchangeRate}
                    onItemAdd={this.onAddQuoteItemModal}
                    location={GlobalHelper.getLocationById(this.state.locationId)} />
            })
            e.preventDefault()
        }.bind(this)
    }

    openSectionAddQuoteItemModal(sectionId, productId) {
        this.setState({
            addItemModal: <AddPricingRow
                mainObject={'quotes'}
                mainObjectItem={'quote-items'}
                objectId={this.quoteId}
                objectIdentifier={this.state.identifier}
                onClose={this.onCloseModal}
                productId={productId}
                sectionId={sectionId}
                currency={this.state.currency}
                exchangeRate={this.state.exchangeRate}
                onItemAdd={this.onAddQuoteItemModal}
                location={GlobalHelper.getLocationById(this.state.locationId)} />
        })
    }

    openEditQuoteItemModal(itemId) {
        this.setState({
            addItemModal: <AddPricingRow
                mainObject={'quotes'}
                mainObjectItem={'quote-items'}
                objectId={this.quoteId}
                objectIdentifier={this.state.identifier}
                onClose={this.onCloseModal}
                itemId={itemId}
                currency={this.state.currency}
                exchangeRate={this.state.exchangeRate}
                onItemAdd={this.onAddQuoteItemModal}
                location={GlobalHelper.getLocationById(this.state.locationId)} />
        })
    }

    addGroup(event) {
        event.preventDefault()
        let groupId = ''
        return AppContext.getApiClient().post('/quotes/' + this.state.quote.id + '/groups', {
            name: this.props.intl.formatMessage(messages['group_default_name']),
            rank: this.state.groups.length
        }).then(g => {
            groupId = g.id
            AppContext.getApiClient().get('/quotes/' + this.state.quote.id).then(quo => {
                this.setState({ groups: quo.attributes.groups }, () => {
                    this.props.setPricingTableGroups(this.state.groups, this.state.quote.id)
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('#sortable-quote-group-' + groupId)?.offset()?.top - 100
                    }, 500)
                })
            })
        })
    }

    setGlobalStateInitialValues() {
        this.props.fetchPriceLevels()
        this.props.setPricingTable(this.state.quote)
    }

    render() {
        let recommendations = ''
        let addProductBtn = ''
        let allowEdit = false
        if (["draft", "new"].includes(this.state.quoteStatus) && !this.state.deletedAt) {
            allowEdit = true
        }
        if (this.state.forceAllowEdit) {
            allowEdit = true
        }

        if (allowEdit) {
            recommendations = this.recommendations().filter(a => a.attributes.sectionId === '').map((advice) => {
                const recommendedProduct = advice.attributes.recommendedProduct
                let image = <Icon value={"image"} style={{ fontSize: '30px' }} />
                if (recommendedProduct.attributes.images.length > 0) {
                    image = <Image imageId={recommendedProduct.attributes.images[0].id} size="very-small" />
                }
                return <div className="col-12 quote-recommendation"
                    key={advice.attributes.objectProductId}
                    onClick={this.openAddQuoteItemModal(advice.attributes.objectProductId)}>
                    <a href="#" className="btn btn-link btn-recommendation">
                        {image} {recommendedProduct.attributes.title}
                    </a>
                </div>
            })

            addProductBtn = <div className="col-12 quote-add-product" onClick={this.openAddQuoteItemModal(null)}>
                <a href="#" className="btn btn-link btn-add-product">
                    <FormattedMessage
                        id="quote.edit.add_product_btn"
                        defaultMessage="Add a product"
                    />
                </a>
            </div>

        }
        if (!this.state.currency) {
            return <div className="row">
                <div className="col-12 ui-module">
                    <LoadingSpinner />
                </div>
            </div>
        } else {
            return (
                <div className="row">
                    <div className={"col-12 " + this.state.className}>
                        <div >
                            <div >
                                <PricingTableContent
                                    tableId={this.state.quote.attributes.pricingTableId || ""}
                                    projectId={this.props.projectId}
                                    advices={this.state.advices}
                                    recommendations={this.recommendations().filter(a => a.attributes.sectionId !== '')}
                                    onUpdate={this.onUpdateItemList}
                                    currency={this.state.currency}
                                    modelId={this.state.modelId}
                                    allowEdit={allowEdit}
                                    sortable={allowEdit}
                                    onEditLinkClick={this.openEditQuoteItemModal}
                                    mainObject={'quotes'}
                                    objectId={this.quoteId}
                                />
                                {recommendations}
                                {addProductBtn}
                            </div>
                        </div>
                        <div className={"row mb-3"}>
                            {allowEdit ? <div className={"col-md-4"}>
                                <div className={"mt-4 pt-2 mb-0 w-100"}>
                                    <button className={"btn btn-outline-primary"} onClick={this.addGroup}>
                                        <Icon value={"layer-group"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.edit.add_group_btn"
                                            defaultMessage="Add a group"
                                        />
                                    </button>
                                </div>
                                {GlobalHelper.getEnabledCurrenciesSelectOptions().length > 1 ?
                                    <div className={"pt-3 w-100"}>
                                        <QuoteCurrency
                                            className={'mr-2 w-100'}
                                            quoteId={this.quoteId}
                                            editable={allowEdit}
                                            currency={this.state.currency}
                                            onChange={this.refreshQuote}
                                        />
                                    </div> : ''}
                                <div className={"pt-3 w-100"}>
                                    <QuoteIdentifier
                                        className={'mr-2 w-100'}
                                        identifierId={this.state.identifierId}
                                        identifier={this.state.identifier}
                                        editable={allowEdit}
                                        onChange={this.refreshQuote}
                                    />
                                </div>
                            </div> : <div className={"col-md-4"} />}
                            <div className={"col-md-8 pb-3"}>
                                <PricingTableTotals
                                    totalClassName={"col-xl-8 col-lg-8 col-md-12"}
                                    allowEdit={allowEdit}
                                    rows={this.state.quoteItems}
                                    quoteId={this.quoteId}
                                    onChange={this.refreshQuote}
                                    depositType={this.state.depositType}
                                    depositAmount={this.state.depositAmount}
                                    depositRatio={this.state.depositRatio}
                                    mainObject={this.state.quote.type}
                                    mainObjectId={this.quoteId}
                                    objectId={this.quoteId}
                                    hideDeposit={this.state.quote.attributes.status === 'ordered'}
                                />
                            </div>
                        </div>
                    </div>
                    {this.state.addItemModal}
                    {this.state.attachCustomerModal}
                </div>
            );
        }
    }
}
const mapState = (state, props) => {
    return { ...props }
}
const mapDispatch =  {
    setPricingTableItems,
    setPricingTableGroups,
    setPricingTableInitialState,
    setPricingTableGroupItems,
    fetchPriceLevels,
    setPricingTable,

    
}
export default connect(mapState, mapDispatch)(injectIntl(QuoteForm))


// WEBPACK FOOTER //
// ./src/quote/form.component.jsx